import Vue from "vue"
import VuePortal from "@linusborg/vue-simple-portal"

Vue.use(VuePortal, {
  name: "portal", // optional, use to rename component
})
